import { render, staticRenderFns } from "./WaiterFamilyTable.vue?vue&type=template&id=0a600dbe&scoped=true&lang=pug"
import script from "./WaiterFamilyTable.vue?vue&type=script&lang=ts"
export * from "./WaiterFamilyTable.vue?vue&type=script&lang=ts"
import style0 from "./WaiterFamilyTable.vue?vue&type=style&index=0&id=0a600dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a600dbe",
  null
  
)

export default component.exports